// Must import first: @/config/env parses its zod schema at module-eval time,
// so this needs to run before that import or the CSP violation fires anyway.
import '@/config/zod';

import { initAnalytics } from '@upms/analytics';
import { initObservability } from '@upms/observability';
import { env } from '@/config/env';
import { processError } from '@/lib/processError';

const serviceName = 'upms---account';

if (env.NODE_ENV !== 'test') {
  initObservability({
    applicationId: env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
    clientToken: env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
    env: env.NEXT_PUBLIC_VERCEL_ENV,
    service: serviceName,
    version: env.NEXT_PUBLIC_GIT_SHA ?? 'local-dev',
  });
  initAnalytics({
    applicationName: serviceName,
    debug: env.NEXT_PUBLIC_PIE_ENV !== 'production',
    environment: env.NEXT_PUBLIC_PIE_ENV,
    token: env.NEXT_PUBLIC_MIXPANEL_TOKEN ?? '',
    isBrowser: typeof window !== 'undefined',
    getPathname: () => window.location.pathname,
    getOrigin: () => window.location.origin,
    onError: (error) => {
      processError(error, { feature: 'analytics', operation: 'init' });
    },
  });
}
